import React from 'react';

interface TabsContainerProps {
  tabColor?: string;
  textColor?: string;
  style?: React.CSSProperties;
  className?: string;
  children?: $FIXME;
}

const TabsContainer: React.FC<TabsContainerProps> = ({
  tabColor = '#247EFF',
  textColor = '#247EFF',
  style,
  className,
  children,
}) => {
  const childs = React.Children.map(children, child => {
    if (!child) return null;
    return React.cloneElement(child as $FIXME, {
      tabColor,
      textColor,
      className,
    });
  }).filter((child: $FIXME) => child !== null);

  return (
    <ul className={className} style={style}>
      {childs.map((child: $FIXME, index: $FIXME) => (
        <li key={index}>{child}</li>
      ))}

      <style jsx>{`
        ul {
          padding: 0;
          margin: 0;
          list-style: none;
          display: block;
          border-bottom: 1px solid #f1f1f1;
        }

        ul:not(.overview) {
          margin-bottom: 20px;
        }

        ul li {
          margin: 0 20px 0 0;
          display: inline-block;
          padding: 0;
        }

        ul li:last-child {
          margin: 0;
        }
      `}</style>
    </ul>
  );
};

export default TabsContainer;
